import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import MonitoringCenterSettings from './MonitoringCenterSettings';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';

interface Props extends BaseModalProps {
	customSettingKey: CustomSettingKey;
	onSave: () => void;
}

const MonitoringCenterSettingsModal: React.FC<Props> = props => (
	<BaseModal {...props} title='component.monitoringCenterSettings.title'>
		<MonitoringCenterSettings
			customSettingKey={props.customSettingKey}
			onSave={props.onSave}
		/>
	</BaseModal>
);

export default MonitoringCenterSettingsModal;
